import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import {
  MutationWithArrayInput,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import {
  HRService,
  setupManagementUrl,
} from "../../../../config";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { CompanyCalendarSetupsFormFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { allRecurringStatus } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const CalendarSetupForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [recurringTypes, setRecurringTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    recurringTypeId: props.data ? props.data.recurringTypeId : "",
    holiday: props.data ? props.data.holiday : "",
    // Ensure holidayDate is formatted as YYYY-MM-DD for input[type=date]
    holidayDate: props.data && props.data.holidayDate
      ? new Date(props.data.holidayDate).toISOString().split("T")[0]
      : "",
    id: props.data ? props.data.id : "",
  };

  // ✅ Fetch Recurring Types
  async function fetchRecurringTypes() {
    try {
      const data = await graphqlQuery(allRecurringStatus, setupManagementUrl.uri);
      if (data) setRecurringTypes(data);
    } catch (error) {
      console.error("Error fetching recurring types:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchRecurringTypes();
  }, []);

  const RecurringTypeOptions = recurringTypes
    ? recurringTypes.map((type) => ({
        value: type.id,
        label: type.type,
      }))
    : [];
    const fields = [
    ...CompanyCalendarSetupsFormFields,
    {
      name: "recurringTypeId",
      label: "Recurring Type",
      type: "select",
      options: RecurringTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
  ];
const steps = [
    {
      stepLabel: "Holiday details",
      stepDescription: "Enter the name and date of the holiday.",
      //icon: "payment",
      fields: ["holiday", "holidayDate"], // ✅ Just names!
    },
    {
      stepLabel: "recurring settings",
      stepDescription: "Specify the recurring type of this holiday.",
      //icon: "settings",
      fields: ["recurringTypeId"], // ✅ Just names!
    },
  ];
  // ✅ Define form fields
  

  // ✅ Step Configuration
  

  // ✅ Submit handler
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { recurringTypeId, holiday, holidayDate } = values;

      const mutationData = {
        recurringTypeId,
        holiday,
        holidayDate,
      };

      if (props.isEditing) mutationData.id = props.data.id;

      const response = await MutationWithArrayInput(
        props.isEditing
          ? "updateCompanyCalendarSetup"
          : "createCompanyCalendarSetup",
        mutationData,
        "setup",
        base_url
      );

      const result = props.isEditing
        ? response.updateCompanyCalendarSetup
        : response.createCompanyCalendarSetup;

      if (result && (result.id || result.id === 0)) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Calendar setup ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred during submission.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ Show loader while fetching
  if (loading) {
    return (
      <div className="flex justify-center items-center p-6">
        <CircularProgress />
      </div>
    );
  }

  // ✅ Render DynamicForm
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={steps}
      onSubmit={handleSubmit}
      title={
        props.isEditing ? "Update Calendar Setup" : "Create Calendar Setup"
      }
      subtitle={
        props.isEditing
          ? "Update an existing calendar setup."
          : "Fill out the form below to create a new calendar setup."
      }
    />
  );
};

export default CalendarSetupForm;
